import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable()
export class ProjectService {
  private baseUrl = environment.API;

  constructor(private http: HttpClient) {}

  load(data?) {
    const url = `${this.baseUrl}/projects/${data && data.id}/`;
    return this.http.get(url);
  }

  create(payload) {
    const url = `${this.baseUrl}/projects/`;
    return this.http.post(url, payload);
  }

  update(id, payload) {
    const url = `${this.baseUrl}/projects/${id}`;
    return this.http.put(url, payload);
  }

  cancel(id) {
    const url = `${this.baseUrl}/projects/${id}/cancel/`;
    return this.http.post(url, { responseType: 'text' });
  }
}
